import { Injectable, OnDestroy } from '@angular/core';
import { Observable, ObservableInput } from 'rxjs';

import { ContentItemWithLayout, Site } from './../../../api';
import { perfMeasure, AnyJson, Generator } from './../../../utils';
import {
  bootstrapClear,
  bootstrapGet,
  bootstrapPut,
  bootstrapPutContentWithLayout,
  bootstrapPutSite,
} from './../../utils/bootstrap.utils';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'BootstrapService';

@Injectable({ providedIn: 'root' })
export class BootstrapService implements OnDestroy {

    constructor() {
        // measure startup
        const handle = perfMeasure(LOGGER);
        // ...
        handle();
    }

    get(aKey: string): Observable<AnyJson> {
        // dispatchj
        return bootstrapGet(aKey);
    }

    put(aKey: string, aValue: AnyJson | string | ObservableInput<AnyJson> | Generator<AnyJson>) {
        return bootstrapPut(aKey, aValue);
    }

    putContentWithLayout(aContext: ContentItemWithLayout | string) {
        bootstrapPutContentWithLayout(aContext);
    }

    putSite(aSite: Site | string) {
        bootstrapPutSite(aSite);
    }

    ngOnDestroy() {
        // delete
        bootstrapClear();
    }
}
